import axios from "axios";
import store from "@/store";
import { getToken, setToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
  baseURL: "", // process.env.BASE_API
  timeout: 20000, // request timeout
  withCredentials: true
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    // Bearer是JWT的认证头部信息
    if (getToken()) {
      config.headers.common["Authorization"] = "Bearer " + getToken();
    }

    //}
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      const { token } = response.data;
      if (token) {
        setToken(token);
      }
    }
    return response;
  },
  error => {
    //console.log("err" + error); // for debug
    // JWT校验失败后登出
    if (JSON.parse(JSON.stringify(error)).response.status === 505) {
      if (store.getters.token) {
        store.dispatch("FedLogOut").then(() => {
          window.location.reload();
        });
      }
      return;
    }
    let errText = JSON.parse(JSON.stringify(error)).response.data;
    return Promise.reject(errText);
  }
);

export default service;
